export default __webpack_public_path__ + "assets/a1.4781a305.jpg";